const body = document.body;

const header = document.querySelector('header');
const headerMenuPanel = document.querySelector('#main-menu');

const topMenu = document.querySelector('.top-menu');
const langs = document.querySelector('.lang-switcher');

const overlayNav = document.querySelector('.cd-overlay-nav');
const toggleNav = document.querySelector('.nav__icon');
const navigation = document.querySelector('.nav');

const menuEl = document.querySelector('#main-menu .menu');
const arrowEl = document.querySelector('.menu-arrow');
const items = document.querySelectorAll('#main-menu .menu > li.link');
const compass = document.querySelector('.compass svg');

const sections = document.querySelectorAll('section[id]');
const sorted = document.querySelector('.sort-icon');

let isMobile = false;
let currentActive = null;
let openMenuTimer = null;
let closeMenuTimer = null;

/* ===============================
 OVERLAY
 =============================== */

function getDiameter() {
    const w = window.innerWidth;
    const h = window.innerHeight;

    return w < 1112
        ? Math.hypot(w, h) * 6
        : Math.hypot(w, h) * 3;
}

function layerInit() {
    if (!overlayNav) return;

    const el = overlayNav.querySelector('span');
    if (!el) return;

    const diameter = getDiameter();

    el.style.transform = 'scale(0)';
    el.style.width = diameter + 'px';
    el.style.height = diameter + 'px';
    el.style.top = -(diameter / 2) + 'px';
    el.style.right = -(diameter / 2) + 'px';
}

/* ===============================
 ADAPTIVE
 =============================== */

function adaptiveMenu() {
    document.querySelectorAll('.js-append').forEach(el => el.remove());

    if (window.innerWidth < 980) {
        if (topMenu) {
            const cloneTm = topMenu.cloneNode(true);
            cloneTm.classList.add('js-append');
            headerMenuPanel.appendChild(cloneTm);
        }

        if (langs) {
            const cloneLangs = langs.cloneNode(true);
            cloneLangs.classList.add('js-append');
            headerMenuPanel.prepend(cloneLangs);
        }
    }
}

/* ===============================
 MOBILE MENU
 =============================== */

function openMenu() {
    clearTimeout(openMenuTimer);
    clearTimeout(closeMenuTimer);

    layerInit();

    body.classList.add('lock', 'open-menu');
    toggleNav.classList.add('active');
    headerMenuPanel?.classList.remove('is-closing', 'visible');
    overlayNav?.classList.remove('is-closing');

    const el = overlayNav?.querySelector('span');

    if (el) {
        el.style.transition = 'transform 0.9s cubic-bezier(0.55, 0, 0.1, 1)';
        el.style.transform = 'scale(1)';
    }

    openMenuTimer = setTimeout(() => {
        navigation?.classList.add('fade-in');
        headerMenuPanel?.classList.add('active');
    }, 600);
}

function closeMenu() {
    clearTimeout(openMenuTimer);
    clearTimeout(closeMenuTimer);

    headerMenuPanel?.classList.add('is-closing');
    headerMenuPanel?.classList.remove('active', 'visible');
    toggleNav.classList.remove('active');
    navigation?.classList.remove('fade-in');
    overlayNav?.classList.add('is-closing');

    const el = overlayNav?.querySelector('span');

    if (el) {
        el.style.transition = 'transform 0.9s cubic-bezier(0.55, 0, 0.1, 1)';
        requestAnimationFrame(() => {
            el.style.transform = 'scale(0)';
        });
    }

    closeMenuTimer = setTimeout(() => {
        body.classList.remove('open-menu', 'lock');
        header?.classList.remove('open-menu');
        headerMenuPanel?.classList.remove('is-closing');
        overlayNav?.classList.remove('is-closing');

        if (el) {
            el.style.transition = 'transform 0.05s ease';
        }
    }, 900);
}

/* ===============================
 DESKTOP MENU (ARROW)
 =============================== */

let currentX = 0;
let targetX = 0;
let baseItem = null;

function getHeaderOffset() {
    const headerHeight = header?.getBoundingClientRect().height || 0;

    return headerHeight ? -(headerHeight + 40) : -130;
}

function getScrollTarget(section) {
    if (!section) return null;

    return section.querySelector('.faq__title, .title, [data-scroll-anchor], h1, h2') || section;
}

function getElementTop(element) {
    let top = 0;
    let current = element;

    while (current) {
        top += current.offsetTop || 0;
        current = current.offsetParent;
    }

    return top;
}

function scrollToSection(section) {
    const target = getScrollTarget(section);
    if (!target) return;

    const targetTop = getElementTop(target) + getHeaderOffset();

    if (window.lenis) {
        window.lenis.scrollTo(Math.max(targetTop, 0), {
            duration: 1.2
        });
        return;
    }

    window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth'
    });
}

function getCenter(item) {
    const span = item.querySelector('span');
    if (!span || !compass) return 0;

    const r = span.getBoundingClientRect();
    const compassRect = compass.getBoundingClientRect();

    return (r.left + r.width / 2) - compassRect.left + 4;
}

function findActive() {
    return document.querySelector('#main-menu .menu > li.link.active') || items[0];
}

function setBasePosition() {
    baseItem = findActive();
    targetX = currentX = getCenter(baseItem);
}

function initDesktopMenu() {
    if (!menuEl || !arrowEl || !items.length) return;

    items.forEach(item => {
        item.addEventListener('mouseenter', () => {
            targetX = getCenter(item);
        });

        item.addEventListener('click', (e) => {
            const link = item.querySelector('a');
            if (!link) return;

            const href = link.getAttribute('href');
            if (!href || !href.startsWith('#')) return;

            const targetSection = document.querySelector(href);
            if (!targetSection) return;

            e.preventDefault();

            items.forEach(i => i.classList.remove('active'));
            item.classList.add('active');

            baseItem = item;
            targetX = getCenter(item);

            scrollToSection(targetSection);
        });
    });

    menuEl.addEventListener('mouseleave', () => {
        if (baseItem) targetX = getCenter(baseItem);
    });

    function animate() {
        currentX += (targetX - currentX) * 0.15;
        arrowEl.style.transform = `translateX(${currentX}px) translateX(-50%)`;
        requestAnimationFrame(animate);
    }

    setBasePosition();
    animate();
}

/* ===============================
 SCROLL SPY (LENIS)
 =============================== */

function initScrollSpy() {
    if (!window.lenis) return;

    window.lenis.on('scroll', ({ scroll }) => {

        if (scroll > 200) body.classList.add('fixed');
        else body.classList.remove('fixed');

        let activeSection = null;
        const headerOffset = Math.abs(getHeaderOffset());

        sections.forEach(section => {
            const top = section.offsetTop - headerOffset;
            const bottom = top + section.offsetHeight;

            if (scroll >= top && scroll < bottom) {
                activeSection = section;
            }
        });

        if (!activeSection) return;

        const id = activeSection.id;
        if (currentActive === id) return;

        currentActive = id;

        items.forEach(item => {
            const link = item.querySelector('a');
            if (!link) return;

            if (link.getAttribute('href') === `#${id}`) {
                items.forEach(i => i.classList.remove('active'));
                item.classList.add('active');

                baseItem = item;
                targetX = getCenter(item);
            }
        });
    });
}

/* ===============================
 EVENTS
 =============================== */

function bindEvents() {

    // burger
    toggleNav?.addEventListener('click', (e) => {
        e.preventDefault();

        if (!toggleNav.classList.contains('active')) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    // dropdown mobile
    document.addEventListener('click', (e) => {
        const link = e.target.closest('.dropdown > a.links');
        if (!link || window.innerWidth >= 980) return;

        e.preventDefault();

        link.classList.toggle('active');
        link.parentElement.querySelector('.dropdown-list')?.classList.toggle('open');
    });

    // close menu on click
    headerMenuPanel?.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (!link) return;

        const parent = link.parentElement;

        if (parent.classList.contains('dropdown') || link.classList.contains('items')) return;

        if (toggleNav.classList.contains('active')) {
            closeMenu();
        }
    });

    // sort
    sorted?.addEventListener('click', () => {
        sorted.nextElementSibling?.classList.toggle('open');
    });
}

/* ===============================
 INIT
 =============================== */

function initMenu() {

    const nowMobile = window.innerWidth < 980;

    adaptiveMenu();
    layerInit();

    if (nowMobile && !isMobile) {
        isMobile = true;
    }

    if (!nowMobile && isMobile) {
        isMobile = false;
        closeMenu();
    }
}

/* ===============================
 BOOT
 =============================== */

let resizeTimer;

window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        initMenu();
    }, 100);
});

document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    initMenu();
    initDesktopMenu();
    initScrollSpy();
});
